module.exports = __webpack_public_path__ + "static/assets/f44e9579ce45c384ed76054ee5e98270.mp3";